import { call, put } from 'redux-saga/effects';

import { IUserPersonalisationResponse } from 'api/components/User/types';
import api from 'api';

import { getUserPersonalisationError, getUserPersonalisationSuccess } from 'store/user/actions';
import { setPlanPersonalisationData } from 'store/personalPlan/actions';
import { notifyError } from 'store/notifications/actions';

import sentry from 'services/Sentry/SentryInstance';

export function* getUserPersonalisation() {
    try {
        const { level, problem_zones, ...personalisationData }: IUserPersonalisationResponse = yield call(
            api.user.getUserPersonalisation
        );

        yield put(setPlanPersonalisationData({ ...personalisationData }));
        yield put(getUserPersonalisationSuccess({ fitness_level: level, problem_zones: problem_zones }));
    } catch (error: any) {
        yield put(getUserPersonalisationError());
        yield put(notifyError({ message: 'message.error.somethingWentWrong' }));
        sentry.sentrySagaLog(error, 'getUserPersonalisation');
    }
}
